import React from "react";

export const MedidasMitigadoras: React.FC = () => {
    return (
        <div className="text-justify">
            <h4 className="text-center">MEDIDAS MITIGADORAS MÍNIMAS</h4>
            <p>
                a) Os níveis de ruído emitidos pela atividade deverão atender ao
                disposto nas Normas Brasileiras (NBR), devendo ser executado o
                projeto de isolamento acústico do estabelecimento, de forma a
                atender a legislação que regula a poluição sonora;
            </p>
            <p>
                b) Os motores de refrigeração (câmara fria, freezer, ar
                condicionado, etc.), bem como outros dispositivos que produzam
                ruídos acima do permitido pela norma brasileira deverão ser
                providos de isolamento acústico;
            </p>
            <p>
                c) As operações mais ruidosas, deverão ser realizadas o mais
                distante possível das edificações e/ou lotes vizinhos e em local
                confinado, obedecidas as normas legais de construção, iluminação
                e ventilação do Município;
            </p>
            <p>
                d) Caso houver equipamentos que produzam choques ou vibrações,
                estes deverão ser assentados em bases próprias e adequadas, a
                fim de evitar incômodos à vizinhança;
            </p>
            <p>
                e) Caso houver operações de solda, estas deverão ser realizadas
                em local adequado, a fim de impedir que o luzimento provocado
                por tal atividade afete os setores vizinhos;
            </p>
            <p>
                f) As instalações de lavagem (inclusive as pulverizações) de
                veículos, deverão ser realizados em compartimento fechado;
            </p>
            <p>
                g) Os despejos de óleo, graxas e gorduras, deverão passar por
                sistema de tratamento, antes de serem lançados em rede pública;
            </p>
            <p>
                h) O processo de pintura por aspersão, deverá ser realizado em
                compartimento próprio, fechado, provido de sistema de ventilação
                local exautora com filtro “cabine de pintura”;
            </p>
            <p>
                i) Atividades que emitam odores fortes e/ou material particulado
                deverão mitigar seu impacto por meio de filtros e outras
                tecnologias usadas para essa finalidade;
            </p>
            <p>
                j) Os resíduos sólidos gerados pela atividade, deverão ter
                destino adequado, sendo vedado dispô-los a céu aberto ou
                incinerá-los;
            </p>
            <p>
                k) No caso de haver fornos à lenha, estes deverão ser providos
                de sistema de filtro (nas chaminés);
            </p>
            <p>
                l) Atividades de impacto sonoro e/ou de manuseio de produtos
                químicos nocivos à saúde devem se localizar a uma distância
                mínima de 100m (cem metros) de equipamentos comunitários,
                hospitais, clínicas, laboratórios, sanatórios, maternidades e
                demais estabelecimentos para atendimento da saúde implantados ou
                programados;
            </p>
            <p>
                m) Postos de combustível devem atender às exigências da
                legislação federal respectiva, das Resoluções do Contran e do
                Conselho Estadual de Trânsito, bem como, sinalização luminosa de
                entrada e saída conforme legislação pertinente;
            </p>
            <p>
                n) Nos casos de polos geradores de tráfego, o número de vagas de
                estacionamento poderá exceder ao determinado pelo código de
                obras municipal, no sentido de se adequar as especificidades da
                atividade;
            </p>
            <p>
                o) Nos casos de polos geradores de tráfego, poderão ser exigidos
                acessos específicos e obras viárias, tais como abertura de novas
                vias, passagens em nível separado, passarelas de pedestres,
                dentre outros, como forma de mitigar o impacto no trânsito da
                vizinhança;
            </p>
            <p>
                p) No caso de atividades geradoras de tráfego de carga, deverá
                ser previsto pátio de carga e descarga de caminhões e acessos
                específicos de veículos de carga.
            </p>
        </div>
    );
};
